export default __webpack_public_path__ + "static/media/2.3e6b8114.png";